/**
 * Vehicle Filters - Apex Style
 * Year filtering for Tacoma parts store with multi-year "My Garage".
 *
 * Features:
 *   - Search Parts: filters by the selected year
 *   - Add To Garage: adds the year to a persistent cookie (supports multiple years)
 *   - Garage auto-filters on page load when years are saved
 *   - Individual year removal from garage via X buttons
 *   - Clear Filters: resets everything and deletes the garage cookie
 */
(function () {
  'use strict';

  var YEAR_PARAM = 'filter.p.m.custom.custom_vehicle_year';
  var MODEL_PARAM = 'filter.p.m.custom.custom_vehiclemodel';
  var MODEL_VALUE = 'Tacoma';

  var GARAGE_COOKIE = 'tacoma_garage_years';
  var GARAGE_MAX_AGE = 60 * 60 * 24 * 90; // 90 days

  // ---- Cookie helpers ----

  function setCookie(name, value, maxAge) {
    document.cookie = name + '=' + encodeURIComponent(value) +
      ';path=/;max-age=' + maxAge + ';SameSite=Lax';
  }

  function getCookie(name) {
    var match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : '';
  }

  function deleteCookie(name) {
    document.cookie = name + '=;path=/;max-age=0;SameSite=Lax';
  }

  // ---- Garage helpers (comma-separated years in cookie) ----

  function getGarageYears() {
    var raw = getCookie(GARAGE_COOKIE);
    if (!raw) return [];
    return raw.split(',').filter(function (y) { return y.trim() !== ''; });
  }

  function saveGarageYears(years) {
    if (years.length === 0) {
      deleteCookie(GARAGE_COOKIE);
    } else {
      setCookie(GARAGE_COOKIE, years.join(','), GARAGE_MAX_AGE);
    }
  }

  function addToGarage(year) {
    var years = getGarageYears();
    if (years.indexOf(year) === -1) {
      years.push(year);
      years.sort(function (a, b) { return parseInt(b) - parseInt(a); }); // newest first
      saveGarageYears(years);
      return true; // added
    }
    return false; // already exists
  }

  function removeFromGarage(year) {
    var years = getGarageYears();
    var idx = years.indexOf(year);
    if (idx !== -1) {
      years.splice(idx, 1);
      saveGarageYears(years);
    }
  }

  // ---- URL helpers ----

  /** Build filter URL with one or more years. Always includes model=Tacoma. */
  function buildFilterUrl(collectionUrl, years) {
    var params = new URLSearchParams();
    params.set(MODEL_PARAM, MODEL_VALUE);

    // years can be a string (single) or array (multiple)
    var yearList = Array.isArray(years) ? years : (years ? [years] : []);
    yearList.forEach(function (y) {
      if (y) params.append(YEAR_PARAM, y);
    });

    // Preserve non-vehicle filters (price, vendor, sort_by, etc.)
    var currentParams = new URLSearchParams(window.location.search);
    currentParams.forEach(function (value, key) {
      if (key !== YEAR_PARAM && key !== MODEL_PARAM) {
        params.set(key, value);
      }
    });

    var qs = params.toString();
    return qs ? collectionUrl + '?' + qs : collectionUrl;
  }

  function parseYearCollections(section) {
    var scriptEl = section.querySelector('script[data-year-collections]');
    if (!scriptEl) return {};
    var raw = scriptEl.textContent.trim();
    if (!raw || raw === '{}') return {};
    try {
      return JSON.parse(raw);
    } catch (e) {
      console.warn('[VehicleFilters] Invalid year-collections JSON:', raw, e);
      return {};
    }
  }

  function detectYearFromCollectionUrl(yearCollections) {
    var path = window.location.pathname.replace(/\/$/, '');
    for (var year in yearCollections) {
      if (yearCollections.hasOwnProperty(year)) {
        var collPath = yearCollections[year].replace(/\/$/, '');
        if (path === collPath) return year;
      }
    }
    return '';
  }

  /**
   * Resolve the best URL for a set of years.
   * Single year on a general page with a SEO collection → clean URL.
   * Multiple years or category pages → query string.
   */
  function resolveFilterUrl(years, useSeoRedirect, yearCollections, collectionUrl) {
    var yearList = Array.isArray(years) ? years.filter(Boolean) : (years ? [years] : []);
    if (yearList.length === 1 && useSeoRedirect && yearCollections[yearList[0]]) {
      return yearCollections[yearList[0]];
    }
    return buildFilterUrl(collectionUrl, yearList);
  }

  // ---- Init ----

  function initFilterBar(section) {
    var yearSelect = section.querySelector('[data-filter-type="year"]');
    var applyButton = section.querySelector('[id^="vf-apply-"]');
    var garageButton = section.querySelector('[id^="vf-garage-"]');
    var garageBadge = section.querySelector('[id^="vf-badge-"]');
    var clearLink = section.querySelector('[id^="vf-clear-"]');

    if (!yearSelect || !applyButton) {
      console.warn('[VehicleFilters] Missing required elements');
      return;
    }

    var collectionUrl = yearSelect.dataset.collectionUrl || '/collections/all';
    var yearCollections = parseYearCollections(section);

    var currentPath = window.location.pathname.replace(/\/$/, '');
    var isOnYearCollection = !!detectYearFromCollectionUrl(yearCollections);
    var isOnGeneralCollection = (
      currentPath === '/collections/all' ||
      currentPath === '/collections' ||
      isOnYearCollection
    );
    var useSeoRedirect = isOnGeneralCollection;

    // Determine active year from URL
    var activeYear = yearSelect.dataset.activeYear || '';
    if (!activeYear) activeYear = detectYearFromCollectionUrl(yearCollections);
    if (!activeYear) activeYear = new URLSearchParams(window.location.search).get(YEAR_PARAM) || '';

    var garageYears = getGarageYears();

    console.log('[VehicleFilters] Init:', {
      collectionUrl: collectionUrl,
      activeYear: activeYear,
      garageYears: garageYears,
      useSeoRedirect: useSeoRedirect,
    });

    // --- Auto-filter from garage cookie ---
    if (garageYears.length > 0 && !activeYear) {
      var autoUrl = resolveFilterUrl(garageYears, useSeoRedirect, yearCollections, collectionUrl);
      console.log('[VehicleFilters] Auto-filtering from garage:', garageYears, autoUrl);
      window.location.href = autoUrl;
      return;
    }

    // Sync dropdown with active year
    if (activeYear) {
      yearSelect.value = activeYear;
    }

    // --- Garage badge with removable tags ---
    function renderGarageBadge() {
      var years = getGarageYears();
      if (!garageBadge) return;

      if (years.length === 0) {
        garageBadge.style.display = 'none';
        return;
      }

      garageBadge.style.display = 'inline-flex';
      var tagsContainer = garageBadge.querySelector('.vehicle-filters-bar__garage-tags');
      tagsContainer.innerHTML = '';

      years.forEach(function (y) {
        var tag = document.createElement('span');
        tag.className = 'vehicle-filters-bar__garage-tag';
        tag.innerHTML = y + ' <button type="button" class="vehicle-filters-bar__garage-tag-remove" data-year="' + y + '" title="Remove ' + y + ' from garage">&times;</button>';
        tagsContainer.appendChild(tag);
      });

      // Attach remove handlers — removing a year refreshes the filter
      tagsContainer.querySelectorAll('.vehicle-filters-bar__garage-tag-remove').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.stopPropagation();
          var yearToRemove = this.dataset.year;
          removeFromGarage(yearToRemove);

          var remaining = getGarageYears();
          if (remaining.length > 0) {
            window.location.href = resolveFilterUrl(remaining, useSeoRedirect, yearCollections, collectionUrl);
          } else {
            window.location.href = collectionUrl;
          }
        });
      });

      updateGarageButtonLabel();
    }

    function updateGarageButtonLabel() {
      if (!garageButton) return;
      var label = garageButton.querySelector('.vehicle-filters-bar__garage-label');
      var years = getGarageYears();
      label.textContent = years.length > 0 ? 'Add To Garage' : 'Add To Garage';
    }

    renderGarageBadge();

    // --- Clear link visibility ---
    function updateClearVisibility() {
      if (clearLink) {
        var hasFilter = yearSelect.value || getGarageYears().length > 0;
        clearLink.style.display = hasFilter ? 'inline-flex' : 'none';
      }
    }
    updateClearVisibility();

    yearSelect.addEventListener('change', function () {
      updateClearVisibility();
    });

    // Expand year dropdown
    var maxVisible = 5;
    yearSelect.addEventListener('mousedown', function () {
      if (this.options.length > maxVisible) {
        this.setAttribute('size', maxVisible);
        this.classList.add('is-expanded');
      }
    });
    yearSelect.addEventListener('change', function () {
      this.setAttribute('size', 1);
      this.classList.remove('is-expanded');
      this.blur();
    });
    yearSelect.addEventListener('blur', function () {
      this.setAttribute('size', 1);
      this.classList.remove('is-expanded');
    });

    // --- Search Parts: filter by the selected dropdown year ---
    function applyFilters() {
      var year = yearSelect.value;
      applyButton.classList.add('is-loading');
      applyButton.setAttribute('disabled', 'disabled');

      var url = resolveFilterUrl(year, useSeoRedirect, yearCollections, collectionUrl);
      console.log('[VehicleFilters] Search Parts:', url);
      window.location.href = url;
    }

    applyButton.addEventListener('click', applyFilters);
    yearSelect.addEventListener('keypress', function (e) {
      if (e.key === 'Enter') applyFilters();
    });

    // --- Add To Garage: add selected year to cookie, then filter by all garage years ---
    if (garageButton) {
      garageButton.addEventListener('click', function () {
        var year = yearSelect.value;
        if (!year) {
          yearSelect.classList.add('vehicle-filters-bar__select--flash');
          setTimeout(function () {
            yearSelect.classList.remove('vehicle-filters-bar__select--flash');
          }, 800);
          return;
        }

        var wasAdded = addToGarage(year);
        var label = garageButton.querySelector('.vehicle-filters-bar__garage-label');

        if (wasAdded) {
          label.textContent = 'Saved!';
          garageButton.classList.add('vehicle-filters-bar__button--saved');
        } else {
          label.textContent = 'Already Saved';
          garageButton.classList.add('vehicle-filters-bar__button--saved');
        }

        setTimeout(function () {
          label.textContent = 'Add To Garage';
          garageButton.classList.remove('vehicle-filters-bar__button--saved');
        }, 1500);

        renderGarageBadge();
        updateClearVisibility();

        // Navigate filtering by all garage years
        applyButton.classList.add('is-loading');
        applyButton.setAttribute('disabled', 'disabled');
        var allYears = getGarageYears();
        var url = resolveFilterUrl(allYears, useSeoRedirect, yearCollections, collectionUrl);
        console.log('[VehicleFilters] Add To Garage + navigate:', allYears, url);
        window.location.href = url;
      });
    }

    // --- Clear Filters: reset everything ---
    if (clearLink) {
      clearLink.addEventListener('click', function (e) {
        e.preventDefault();
        yearSelect.value = '';
        deleteCookie(GARAGE_COOKIE);
        renderGarageBadge();
        updateClearVisibility();
        applyButton.classList.add('is-loading');
        window.location.href = collectionUrl;
      });
    }
  }

  // Initialize
  function init() {
    var sections = document.querySelectorAll('.vehicle-filters-section');
    if (sections.length === 0) return;
    sections.forEach(initFilterBar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
